enum MainInvoiceAgreementStatus {
  PROSPECT = 'PROSPECT',
  ACTIVE = 'ACTIVE',
  POSTPONED = 'POSTPONED',
  INACTIVE = 'INACTIVE',
  NOPROSPECT = 'NOPROSPECT',
}

export default MainInvoiceAgreementStatus;
